// Ctrl+V 接管协调标记：keydown 先于 paste 事件触发，内部节点粘贴延迟到 setTimeout 再决策；
// paste 监听器发现系统剪贴板携带文件时写入本标记，延迟回调据此跳过内部粘贴（方案 §4.4）。
// 独立为纯工具模块，供 hooks/useKeyboardShortcuts 与 hooks/useExternalFileUpload 两处导入，
// 避免 hooks 层反向依赖 components 层。
const TAKEOVER_WINDOW_MS = 250;

let filePasteTakenOverAt = 0;

export const markFilePasteTakeover = () => {
  filePasteTakenOverAt = Date.now();
};

export const isFilePasteTakeover = () => Date.now() - filePasteTakenOverAt < TAKEOVER_WINDOW_MS;
